package com.patronat.top.dto

import kotlinx.serialization.Serializable

@Serializable
data class RegisterRequest(
    val firstName: String,
    val lastName: String,
    val phoneNumber: String,
    val email: String? = null,
    val userRole: UserRole
)

@Serializable
data class LoginRequest(
    val login: String,
    val authMethod: AuthMethod
)


@Serializable
data class PhoneNumberConfirmRequest(
    val phoneNumber: String,
    val code: String,
    val flow: AuthFlow
)

@Serializable
data class EmailConfirmRequest(
    val email: String,
    val code: String,
    val flow: AuthFlow
)

@Serializable
data class ResendPhoneCodeRequest(
    val phone: String
)

@Serializable
data class ResendEmailCodeRequest(
    val email: String
)

@Serializable
data class RefreshTokenRequest(
    val refreshToken: String
)
